import React from 'react';
import { ApolloClient, createNetworkInterface, ApolloProvider } from 'react-apollo';

import CoreLayout from './layouts/PageLayout/PageLayout';
import SettleMagicLinkRoute from './routes/SettleMagicLinkRoute';

export const createRoutes = (store) => {
  return ({
    path        : 'magic/:Address/:Token',
    component   : props => {
      let GraphQLURI = __GraphQLPublic; // eslint-disable-line no-undef

      let ApolloNetworkInstance = createNetworkInterface({
        uri: GraphQLURI,
        opts: {
          headers: {
            'Authorization': 'Bearer unauthed',
          },
        },
      });

      let ApolloClientInstance = new ApolloClient({
        networkInterface: ApolloNetworkInstance,
      });

      return (
        <ApolloProvider client={ApolloClientInstance}>
          <CoreLayout store={store} {...props} />
        </ApolloProvider>
      );
    },
    indexRoute: SettleMagicLinkRoute(store),
  });
};

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/magic/index.js